const normalizeResolvedComposerSurfaceMode = (value) => {
  const normalizedValue = String(value || '')
    .trim()
    .toLowerCase();

  if (normalizedValue === 'schedule' || normalizedValue === 'schedule_run') {
    return 'schedule';
  }

  if (normalizedValue === 'trigger' || normalizedValue === 'trigger_run') {
    return 'trigger';
  }

  if (normalizedValue === 'workflow' || normalizedValue === 'workflow_requirements') {
    return 'workflow';
  }

  if (normalizedValue === 'onboarding') {
    return 'onboarding';
  }

  if (normalizedValue === 'analytics') {
    return 'analytics';
  }

  return '';
};

export default normalizeResolvedComposerSurfaceMode;
